import React from 'react';
import classnames from 'classnames';
import TextRenderer from '../../../TextRenderer';
import { LongStatusViewer } from '../../../DaEditorWrapper/Viewer/Status';
import draftTheme from '../../../DaEditorWrapper/Themes/Viewer/feedcard.scss';
import legacyTheme from '../../Feed/feedcard.legacy.theme.scss';
import s from './LongStatus.scss';
var LongStatusFeedCardContents = function (_a) {
    var deviation = _a.deviation;
    return (React.createElement(TextRenderer, { textContent: deviation.textContent, reactViewer: LongStatusViewer, viewerKey: deviation.deviationId, legacyTheme: "status", fixedParagraph: false, draftjsThemeOverride: draftTheme, className: classnames(s['content'], legacyTheme['legacy'], legacyTheme['override'], draftTheme['override']) }));
};
LongStatusFeedCardContents.displayName = 'LongStatusFeedCardContents';
export default LongStatusFeedCardContents;
//# sourceMappingURL=LongStatus.js.map